<template>
  <section
    :id="`${cms.scroll_id}`"
    v-editable="cms"
    :class="[name, spacing]"
    :style="mainCssVars"
  >
    <grid
      :class="['grid--container', `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '0 6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="[`${name}__grid-item`, `${name}__filter-list`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 2, x: 1, width: 24 },
        ]"
      >
        <m-filter-office
          :class="`${name}__filter`"
          @onOfficeFilterClick="onOfficeFilterClick"
        />
      </grid-item>
    </grid>
    <grid
      :class="['grid--container', `${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '0 6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="`${name}__grid-item`"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 24 },
        ]"
      >
        <div :class="`${name}__offices`">
          <component
            :is="item.component"
            v-for="(item, index) in filteredCollection"
            :key="index"
            v-editable="item"
            :cms="item"
            :class="`${name}__card`"
          />
        </div>
      </grid-item>
    </grid>
  </section>
</template>

<script>
import data from '~/components/organisms/o-x3-column-text/o-x3-column-text.data'
import Colors from '~/mixins/colors'
import MFilterOffice from '~/components/molecules/m-filters/m-filter-office'
import MCardOffice from '~/components/molecules/m-cards/m-card-office'
export default {
  components: { MFilterOffice, MCardOffice },
  mixins: [Colors],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
  },

  data() {
    return {
      name: 'o-list-offices-v2',
      checkedOffices: [],
    }
  },

  computed: {
    filteredCollection() {
      if (!this.checkedOffices.length) return this.cms.collection
      return this.cms.collection.filter((item) =>
        this.checkedOffices.includes(item.region)
      )
    },
    spacing() {
      return this.cms.spacing
    },
    mainCssVars() {
      return {
        '--bg-color': this.setColor(
          (this.cms.color_background || {}).color || '#FFFFFF',
          this.cms.color_gradient
        ),
        '--text-color': this.setColor(
          (this.cms.color_text || {}).color || '#000000'
        ),
        '--hover-color': this.setColor(
          (this.cms.color_hover || {}).color || '#C33CA8'
        ),
        '--disabled-color': this.setColor(
          (this.cms.color_disabled || {}).color || '#888b8d'
        ),
      }
    },
  },
  methods: {
    onOfficeFilterClick(values) {
      this.checkedOffices = values
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.o-list-offices-v2 {
  transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
    border 0.2s ease-in-out;
  background: var(--bg-color);
  border-color: var(--text-color);
  color: var(--text-color);
  padding: 43px 0 100px;

  ::v-deep a,
  ::v-deep .a-cta {
    color: var(--text-color);
    &:hover,
    &:active {
      color: var(--hover-color);
    }
    &:disabled,
    &.disabled {
      color: var(--disabled-color);
    }
  }

  &__offices {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 10px;
  }
}

@include media-breakpoint-up(md) {
  .o-list-offices-v2 {
    &__offices {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
@include media-breakpoint-up(lg) {
  .o-list-offices-v2 {
    &__offices {
      grid-template-columns: repeat(2, 1fr);
    }
  }
}
@include media-breakpoint-up(xl) {
  .o-list-offices-v2 {
    &__offices {
      grid-template-columns: repeat(3, 1fr);
    }
  }
}
</style>
